import React from "react";
import PropTypes from "prop-types";
import AsyncSelect from "react-select/lib/Async";
import { fetchJson } from "../../lib/Fetching";

class MatrixInput extends React.Component {
  state = {
    focused: false,
    defaultOptions: [],
    selectedOptions: []
  };

  onBlur = () => {
    this.setState({ focused: false });
  };

  onFocus = () => {
    this.setState({ focused: true });
  };

  placeholder = () => {
    const { multiple } = this.props;
    const { focused } = this.state;
    return focused
      ? I18n.t("start_typing_to_filter_matrices")
      : multiple
        ? I18n.t("find_matrices")
        : I18n.t("find_matrix");
  };

  fetchData = search =>
    fetchJson("/matrices.json", { "form[search]": search }).then(records =>
      records.map(m => ({ label: m.name, value: m.id }))
    );

  customStyles = () => {
    const { width, defaultStyle } = this.props;
    if (defaultStyle) return {};
    return {
      control: (base, state) => ({
        ...base,
        width: width || 300
      })
    };
  };

  componentDidMount() {
    this.fetchDefaultOptions();
    this.fetchSelectedOptions();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value) {
      this.fetchSelectedOptions();
    }
  }

  fetchDefaultOptions = async () => {
    const { defaultIds } = this.props;
    if (defaultIds && defaultIds.length > 0) {
      const records = await fetchJson("/matrices.json", { "ids": defaultIds });
      const options = records.map(m => ({ label: m.name, value: m.id }));
      this.setState({ defaultOptions: options });
    }
  }

  fetchSelectedOptions = async () => {
    const { value } = this.props;
    if (value && value.length > 0) {
      const records = await fetchJson("/matrices.json", { "ids": value });
      const options = records.map(m => ({ label: m.name, value: m.id }));
      this.setState({ selectedOptions: options });
    } else {
      this.setState({ selectedOptions: [] });
    }
  }

  render() {
    const {
      onChange,
      multiple,
      defaultValue,
      defaultIds,
      value
    } = this.props;
    const { 
      defaultOptions,
      selectedOptions
    } = this.state;
    
    // Use value prop if provided, otherwise fall back to defaultIds
    const shouldUseValue = value !== undefined;
    const optionsToUse = shouldUseValue ? selectedOptions : defaultOptions;
    const isLoading = shouldUseValue ? 
      (value && value.length > 0 && selectedOptions.length === 0) :
      (defaultIds && defaultIds.length > 0 && defaultOptions.length === 0);
    
    if (isLoading) {
      return <div>Loading...</div>;
    }
    
    return (
      <AsyncSelect
        defaultOptions={!shouldUseValue && defaultOptions.length > 0}
        defaultValue={!shouldUseValue ? defaultOptions : undefined}
        value={shouldUseValue ? optionsToUse : undefined}
        placeholder={this.placeholder()}
        onFocus={this.onFocus}
        onBlur={this.onBlur}
        isMulti={multiple}
        simpleValue={true}
        autoload={true}
        styles={this.customStyles()}
        id="matrix_id"
        loadOptions={this.fetchData}
        isClearable
        onChange={onChange}
      />
    );
  }
}

export default MatrixInput;
